.container {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1.2rem 0.85rem;
  border-radius: 0.3rem;
  border-top: 1px solid #e0e0e0;
  justify-content: space-between;
}

.header:hover {
  cursor: pointer;
  background-color: #f5f5f7;
}

.buttonsView {
  display: flex;
  gap: 2rem;
}

.tagsView {
  display: flex;
  gap: 1rem;
}

.dropDown {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 0 0.85rem 1.8rem 0.85rem;
  border-radius: 0.3rem;
}

.dropDownItems {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}
